import * as types from './types';

export const reset = () => ({
  type: types.RESET,
});
